import { m } from "@/paraglide/messages";

/** "Not medical advice" note shown under every health calculator. */
export function HealthDisclaimer() {
  return (
    <p className="mt-5 rounded-lg border border-border bg-card/40 p-3 text-xs leading-relaxed text-muted-foreground">
      {m.bmi_disclaimer()}
    </p>
  );
}
